<template>
	<div class="w-5 space-y-0.5 py-0.5">
		<div
			class="h-0.75 w-full transition-all duration-100"
			:class="{
				'bg-label-tertiary': value <= 75,
				'bg-red-dark': 75 < value,
				'-translate-y-1 opacity-0': !loaded
			}"
		/>
		<div
			class="h-0.75 w-full transition-all duration-200"
			:class="{
				'bg-label-tertiary': value <= 50,
				'bg-orange-dark': 50 < value && value <= 75,
				'bg-red-dark': 75 < value,
				'-translate-y-1 opacity-0': !loaded
			}"
		/>
		<div
			class="h-0.75 w-full transition-all duration-300"
			:class="{
				'bg-label-tertiary': value <= 25,
				'bg-yellow-dark': 25 < value && value <= 50,
				'bg-orange-dark': 50 < value && value <= 75,
				'bg-red-dark': 75 < value,
				'-translate-y-1 opacity-0': !loaded
			}"
		/>
		<div
			class="h-0.75 w-full transition-all duration-400"
			:class="{
				'bg-green-dark': 0 <= value && value <= 25,
				'bg-yellow-dark': 25 < value && value <= 50,
				'bg-orange-dark': 50 < value && value <= 75,
				'bg-red-dark': 75 < value,
				'-translate-y-1 opacity-0': !loaded
			}"
		/>
	</div>
</template>
<script setup lang="ts">
import { sleep } from '@/utils/sleep'
import { ref } from 'vue'

defineProps<{
	value: number
}>()

const loaded = ref(false)

const onLoad = async () => {
	await sleep(300)
	loaded.value = true
}

onLoad()
</script>
